var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 800",
    role: "img",
    "aria-label": "Document placeholder",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 800,
    fill: "#f1f5f9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 80,
    width: 420,
    height: 640,
    rx: 24,
    fill: "#ffffff",
    stroke: "#e2e8f0",
    strokeWidth: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 160,
    width: 320,
    height: 24,
    rx: 12,
    fill: "#94a3b8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 220,
    width: 260,
    height: 20,
    rx: 10,
    fill: "#cbd5f5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 260,
    width: 300,
    height: 20,
    rx: 10,
    fill: "#cbd5f5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 320,
    width: 220,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 360,
    width: 260,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 400,
    width: 200,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 480,
    width: 300,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 520,
    width: 240,
    height: 18,
    rx: 9,
    fill: "#e2e8f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPaper);
export default __webpack_public_path__ + "static/media/default-paper.63950c2cea691442c6463651a754cdf1.svg";
export { ForwardRef as ReactComponent };